import { useNavigate } from 'react-router-dom';

/**
 * Back, as a native app (Gary, 16 Oct): the in-app back arrow steps back through history,
 * the same as Android's back button, instead of opening the parent screen as a new page.
 * Opening a new page made Android's back walk forward again through every screen visited.
 * When there is nothing to go back to (the app opened straight on this screen, from a
 * notification or a restart), it opens the parent in place of this screen.
 *
 * "Nothing to go back to" is read from React Router's own history index, not location.key
 * (mobile review, 19 Oct): replacing the first page gives it a real key while the index stays
 * 0, so the second back tap stepped out of the app, or did nothing in a home-screen app.
 */
export function useGoBack(): (parent: string) => void {
  const navigate = useNavigate();
  return (parent: string) => {
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate(parent, { replace: true });
  };
}
